import { Subscription } from '@cel_cash/core/types'
import ConfirmarExclusao from 'global/guides/Dialog/ConfirmarExclusao'
import { useState } from 'react'
import { useNavigate, useOutletContext } from 'react-router-dom'
import { assinaturas } from 'service/api'
import tokenRefresher from 'service/api/token-refresher'
import { toast } from 'sonner'

type OutletContext = {
    assinatura?: Subscription
}

export default function CancelarAssinatura() {
    const { assinatura } = useOutletContext<OutletContext>()
    const [isLoading, setIsLoading] = useState(false)
    const navigate = useNavigate()

    const handleSubmit = async () => {
        if (!assinatura) return

        setIsLoading(true)
        return assinaturas
            .delete('minha-assinatura')
            .then(async () => {
                toast.success('Assinatura cancelada com sucesso!')

                await Promise.all([
                    assinaturas.invalidateQueries(),
                    assinaturas.minhaAssinatura.invalidateQueries(),
                ])

                await tokenRefresher.refreshToken()
                navigate('/planos/me')
                window.location.reload()
            })
            .catch(e => {
                toast.error(e.message)
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    return (
        <ConfirmarExclusao
            loading={isLoading}
            onConfirm={handleSubmit}
            cancelar="Não, voltar"
            title="Tem certeza que deseja cancelar sua assinatura?"
        >
            Você perderá acesso ao sistema no final do período de faturamento
            atual.
        </ConfirmarExclusao>
    )
}
